import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import TagsPage from 'flarum/tags/components/TagsPage';

export default function extendTagOverview() {
  extend(TagsPage.prototype, 'view', function (markup) {
    if (app.forum.attribute('support_knowledge_base_hide_tags') == false) return markup;

    // Get knowledge base tag ID's
    const knowledgeBaseTags = app.forum.attribute('support_knowledge_base_tags') || [];

    // Make sure all the children exists before continuing
    if (!markup.children[1] || !markup.children[1].children[1] || !markup.children[1].children[1].children[0]) {
      return markup;
    }

    // Get tiles
    let tag_tiles = markup.children[1].children[1].children[0].children;

    // Map through the tiles and remove tiles that are part of the knowledge base
    markup.children[1].children[1].children[0].children = tag_tiles.map((tile, i) => {
      return knowledgeBaseTags.indexOf(this.tags[i].id()) >= 0 ? null : tile;
    });

    return markup;
  });
}
